// Project thubnail
import onekmountains from 'assets/img/avatar/1kmountains.jpg';
import ChunHoLum from 'assets/img/avatar/ChunHoLum.jpg';
import Fhy from 'assets/img/avatar/Fhy.jpg';
import Me from 'assets/img/avatar/ME.jpg';
import anvilSquad1 from 'assets/img/projects/anvil-squad/anvil-squad1.jpg';
import anvilSquad2 from 'assets/img/projects/anvil-squad/anvil-squad2.jpg';
import anvilSquad3 from 'assets/img/projects/anvil-squad/anvil-squad3.jpg';
import anvilSquad4 from 'assets/img/projects/anvil-squad/anvil-squad4.jpg';
import anvilSquad5 from 'assets/img/projects/anvil-squad/anvil-squad5.jpg';
import anvilSquad from 'assets/img/projects/AnvilSquad.jpg';
import artofLife from 'assets/img/projects/ArtofLife.jpg';
import entranc from 'assets/img/projects/Entranc.jpg';
import forestDefenders from 'assets/img/projects/ForestDefenders.jpg';
import ghostlyDelivery from 'assets/img/projects/GhostlyDelivery.jpg';
import ghostlyDelivery1 from 'assets/img/projects/ghostlyDelivery/ghostlyDelivery1.jpg';
import ghostlyDelivery2 from 'assets/img/projects/ghostlyDelivery/ghostlyDelivery2.jpg';
import ghostlyDelivery3 from 'assets/img/projects/ghostlyDelivery/ghostlyDelivery3.jpg';
import hanabi from 'assets/img/projects/Hanabi.jpg';
import hanabi1 from 'assets/img/projects/hanabi/hanabi1.jpg';
import hanabi2 from 'assets/img/projects/hanabi/hanabi2.jpg';
import hanabi3 from 'assets/img/projects/hanabi/hanabi3.jpg';
import hanabi4 from 'assets/img/projects/hanabi/hanabi4.jpg';
import magnoliaLab from 'assets/img/projects/MagnoliaLab.jpg';
import managarmr from 'assets/img/projects/Managarmr.jpg';
import managarmr1 from 'assets/img/projects/managarmr/managarmr1.jpg';
import managarmr2 from 'assets/img/projects/managarmr/managarmr2.jpg';
import managarmr3 from 'assets/img/projects/managarmr/managarmr3.jpg';
import morningStar1 from 'assets/img/projects/morning-star/morning-star1.jpg';
import morningStar2 from 'assets/img/projects/morning-star/morning-star2.jpg';
import morningStar3 from 'assets/img/projects/morning-star/morning-star3.jpg';
import morningStar from 'assets/img/projects/MorningStar.jpg';
import oneStepBeats from 'assets/img/projects/OneStepBeats.jpg';
import onikiri from 'assets/img/projects/Onikiri.jpg';
import onikiri1 from 'assets/img/projects/onikiri/onikiri1.jpg';
import onikiri2 from 'assets/img/projects/onikiri/onikiri2.jpg';
import onikiri3 from 'assets/img/projects/onikiri/onikiri3.jpg';
import pixelArtWeaponChallenge from 'assets/img/projects/PixelArtWeaponChallenge.jpg';
import portfolioSite from 'assets/img/projects/PortfolioSite.jpg';
import repairGrandson from 'assets/img/projects/Repair-Grandson.jpg';
import repairGrandson1 from 'assets/img/projects/repair-grandson/repair-grandson1.jpg';
import repairGrandson2 from 'assets/img/projects/repair-grandson/repair-grandson2.jpg';
import repairGrandson3 from 'assets/img/projects/repair-grandson/repair-grandson3.jpg';
import steamtown from 'assets/img/projects/Steamtown.jpg';
import steamtown1 from 'assets/img/projects/steamtown/steamtown1.jpg';
import steamtown2 from 'assets/img/projects/steamtown/steamtown2.jpg';
import steamtown3 from 'assets/img/projects/steamtown/steamtown3.jpg';
import valhalla from 'assets/img/projects/Valhalla.jpg';
// Project snapshots
import valhalla1 from 'assets/img/projects/valhalla/valhalla1.jpg';
import valhalla2 from 'assets/img/projects/valhalla/valhalla2.jpg';
import valhalla3 from 'assets/img/projects/valhalla/valhalla3.jpg';
import valhalla4 from 'assets/img/projects/valhalla/valhalla4.jpg';
import valhalla5 from 'assets/img/projects/valhalla/valhalla5.jpg';
import { ReactComponent as ApplicationIcon } from 'assets/img/ui/application.svg';
import { ReactComponent as ArtIcon } from 'assets/img/ui/art.svg';
import { ReactComponent as DesignIcon } from 'assets/img/ui/design.svg';
import { ReactComponent as GameIcon } from 'assets/img/ui/game.svg';
import { ReactComponent as MachineLearningIcon } from 'assets/img/ui/machine-learning.svg';
import { ReactComponent as WebIcon } from 'assets/img/ui/web.svg';
import { ForestDefendersWidget, GhostlyDeliveryWidget, ManagarmaWidget, MorningStarWidget, OnikiriWidget, RepairGrandsonWidget } from '../../components/ItchWidget/ItchWidget';


export const projectTypes = ["Game", "Web", "Art", "Design", "Application", "Machine Learning", "Other"]

export const authorDict = {
    "ME": {
        icon: Me,
        link: "http://boreashe.github.io"
    },
    "Fhy": {
        icon: Fhy,
        link: "http://jack-szeto.github.io"
    },
    "1kmountains": {
        icon: onekmountains,
        link: "http://jasonleung2468.wixsite.com/portfolio"
    },
    "ChunHoLum": {
        icon: ChunHoLum,
        link: "http://lumchunho.app"
    }
};

export const typeClassificationConfig = {
    "Game": {
        color: "#ffd866",
        icon: GameIcon,
        subtypes: [
            "Unity C#",
            "Game Mechanism Design",
            "Gameplay Programming",
            "Level Design"
        ]
    },
    "Web": {
        color: "#a9dc76",
        icon: WebIcon,
        subtypes: [
            "HTML + CSS",
            "Node.js",
            "Express.js",
            "React.js",
            "Phaser",
            "Data Visualization",
            "Django",
            "SVG"
        ]
    },
    "Art": {
        color: "#ff6188",
        icon: ArtIcon,
        subtypes: [
            "Pixel Art"
        ]
    },
    "Design": {
        color: "#ab9df2",
        icon: DesignIcon,
        subtypes: [
            "UI/UX Design",
            "Graphics Design"
        ]
    },
    "Application": {
        color: "#78dce8",
        icon: ApplicationIcon,
        subtypes: [
            "Prototyping",
            "Socket Networking",
            "Database",
            "Python",
            "Dart",
            "Flutter",
            "C++",
            "Arduino",
            "BLE"
        ]
    },
    "Machine Learning": {
        color: "#fc9867",
        icon: MachineLearningIcon,
        subtypes: [
            "Machine Learning",
            "Data Science"
        ]
    }
}

export const projects = {
    "Steamtown": {
        type: ["Game", "Design"],
        thumbnail: steamtown,
        shortDesc: "Submission to GGJ-HK 2022",
        desc: "A card game I and my teammates made at Global Game Jam (GGJ) Hong Kong 2022 themed \"Duality\".",
        tags: ["C#", "Unity"],
        palette: {
            primary: "#5D4333",
            secondary: "#5D4333",
            chip: "#745422",
            text: "#e6dec9",
            chip_text: "#d8c796"
        },
        exp: [
            ["Unity C#", 10],
            ["Gameplay Programming", 10],
            ["Game Mechanism Design", 4],
            ["Level Design", 4],
            ["UI/UX Design", 7]
        ],
        onClickAction: "dialog",
        slides: [
            {
                desc: "Made with \"Duality\" theme featured on Global Game Jam 2022. I finished the card system and UI controller part.",
                image: steamtown1
            },
            {
                desc: "Players choose one side of the card to resolve while the opponent will resolve another side.",
                image: steamtown2
            },
            {
                desc: "There are several story battles in this game and each of the enemy has a unique ability.",
                image: steamtown3
            }
        ],
        authors: [
            "ME",
            "Fhy",
            "1kmountains",
            "ChunHoLum"
        ],
    },
    "Anvil Squad": {
        type: ["Game", "Design", "Art"],
        thumbnail: anvilSquad,
        shortDesc: "Solo Game Project",
        desc: "A dice rolling RPG game I made for my Game Design course project. All parts of the game(coding an art) is done by me.",
        tags: ["C#", "Unity"],
        onClickAction: "dialog",
        slides: [
            {
                desc: "Players need to forge material dice into battle dice.",
                image: anvilSquad1
            },
            {
                desc: "The power inside the material dice will be fused into the forging battle die.",
                image: anvilSquad2
            },
            {
                desc: "Players can assign battle dice and skills to squad members.",
                image: anvilSquad3
            },
            {
                desc: "Each battle die will be rerolled once cooled down. Players can assign them into squad member's slots.",
                image: anvilSquad4
            },
            {
                desc: "Once the skill activation requirement is fulfilled by power in the assigned battle dice, the skill will be unleashed.",
                image: anvilSquad5
            }
        ],
        palette: {
            primary: "#b7b048",
            secondary: "#f28135",
            chip: "#745422",
            text: "#ffff73",
            chip_text: "#d8c796"
        },
        exp: [
            ["Unity C#", 14],
            ["Gameplay Programming", 14],
            ["Game Mechanism Design", 28],
            ["Level Design", 7],
            ["UI/UX Design", 28],
            ["Pixel Art", 28],
            ["Graphics Design", 7],
        ],
        authors: [
            "ME"
        ],
    },
    "One-Step Beats": {
        type: ["Application", "Design"],
        thumbnail: oneStepBeats,
        shortDesc: "Prototyping Course Project",
        desc: "An Arduino prototype of an integrated system that adjust music by jogger's run speed. Includes an ESP32 board as BLE server and an Android device as controller and music player.",
        onClickAction: "href",
        link: "https://github.com/BoreasHe/SD5509_Demo",
        palette: {
            primary: "#7C98A6",
            secondary: "#7C98A6",
            chip: "#766E79",
            text: "#013E2D",
            chip_text: "#C0B4C4"
        },
        exp: [
            ["C++", 4],
            ["Arduino", 7],
            ["BLE", 4],
            ["Dart", 7],
            ["Flutter", 7],
            ["UI/UX Design", 7],
        ],
        authors: [
            "ME", "JunoChen", "CindyWang"
        ],
    },
    "Morning Star": {
        type: ["Game", "Design"],
        thumbnail: morningStar,
        shortDesc: "Submission to Brackeys 2021.2",
        desc: "A 2D puzzle game I and my teammates made at Brackeys Game Jam 2021.2 themed \"Let there be chaos\".",
        tags: ["C#", "Unity"],
        onHoverComponent: MorningStarWidget,
        onClickAction: "dialog",
        slides: [
            {
                desc: "Made with \"Let there be chaos\" theme featured on Brackeys Game Jam 2021.2. I finished UI controller, the level editor and some game logic part.",
                image: morningStar1
            },
            {
                desc: "Players need to fill each of the grid in the level with chaos, by envocating different elements or just walking on it.",
                image: morningStar2
            },
            {
                desc: "Players can also build their own levels and share will others.",
                image: morningStar3
            }
        ],
        palette: {
            primary: "#b7b048",
            secondary: "#694A79",
            chip: "#745422",
            text: "#C8C48F",
            chip_text: "#d8c796"
        },
        exp: [
            ["Unity C#", 7],
            ["Gameplay Programming", 7],
            ["Game Mechanism Design", 2],
            ["Level Design", 1],
            ["UI/UX Design", 7]
        ],
        leftText: "Top 6%",
        authors: [
            "ME",
            "Fhy",
            "1kmountains",
            "ChunHoLum"
        ],
    },
    "30D challenge (1)": {
        type: ["Art", "Design"],
        thumbnail: pixelArtWeaponChallenge,
        shortDesc: "2021/07 Pixel art weapon challenge",
        desc: "I want to learn pixel art therefore I started this 30-day challenge. Canvas size 32x32, featuring weapons.",
        tags: ["HTML", "CSS", "JavaScript", "React.js",],
        palette: {
            primary: "#0f1f33",
            secondary: "#666666",
            chip: "#706862",
            text: "#f2f2f2",
            chip_text: "#f2f2f2"
        },
        exp: [
            ["Pixel Art", 30],
            ["Graphics Design", 14],
        ],
        authors: [
            "ME"
        ],
    },
    "Magnolia Lab": {
        type: ["Web"],
        thumbnail: magnoliaLab,
        shortDesc: "\"Mixology meets Herbology\"",
        desc: "My freelance project. Magnolia Lab is a brand which is inspired by the ancient tradition of medicinal liquor infusion, delivering their botanical liqueurs: Magnolia and Roselle.",
        tags: ["HTML", "CSS", "JavaScript", "React.js",],
        onClickAction: "href",
        link: "https://magnolia-lab.com/",
        palette: {
            primary: "#E9DBB9",
            secondary: "#B28147",
            chip: "#FFF5D9",
            text: "#F8F3E8",
            chip_text: "#867056"
        },
        exp: [
            ["React.js", 21],
            ["HTML + CSS", 14],
            ["Node.js", 7],
            ["SVG", 4]
        ],
        authors: [
            "ME",
            "Fhy",
        ],
    },
    "Forest Defenders": {
        type: ["Game", "Design"],
        thumbnail: forestDefenders,
        shortDesc: "Submission to GMTK 2021",
        desc: "A 2D tower defense game I and my teammates made at GMTK Game Jam 2021  themed \"Joined Together\".",
        tags: ["C#", "Unity"],
        onHoverComponent: ForestDefendersWidget,
        palette: {
            primary: "#b7b048",
            secondary: "#d8c796",
            chip: "#745422",
            text: "#553b1b",
            chip_text: "#d8c796"
        },
        exp: [
            ["Unity C#", 2],
            ["Game Mechanism Design", 2],
            ["Gameplay Programming", 2],
            ["UI/UX Design", 2]
        ],
        authors: [
            "ME",
            "Fhy",
            "1kmountains",
        ],
    },
    "Ghostly Delivery": {
        type: ["Game", "Design"],
        thumbnail: ghostlyDelivery,
        shortDesc: "Submission to Brackeys 2021.1",
        desc: "A 2D strategy game I and my teammates made at Brackeys Jam 2021.1 themed \"Stronger together\".",
        tags: ["C#", "Unity"],
        onClickAction: "dialog",
        slides: [
            {
                desc: "Made with \"Stronger Together\" theme featured on Brackeys Jam 2021.1. I finished the random generation and UI logic part.",
                image: ghostlyDelivery1
            },
            {
                desc: "Players control ghost minions to deliver cargo through the city portal.",
                image: ghostlyDelivery2
            },
            {
                desc: "Players need to reach lv. 10 before using up all life points or remaining minions",
                image: ghostlyDelivery3
            }
        ],
        authors: [
            "ME",
            "Fhy",
            "1kmountains",
        ],
        exp: [
            ["Unity C#", 4],
            ["Game Mechanism Design", 4],
            ["Gameplay Programming", 4],
            ["UI/UX Design", 4]
        ],
        leftText: "TOP 8%",
        link: "https://fhy.itch.io/ghostly-delivery",
        onHoverComponent: GhostlyDeliveryWidget,
        palette: {
            primary: "#284a5a",
            secondary: "#f52e54",
            chip: "#255e7b",
            text: "#ffffff",
            chip_text: "#ffffff"
        }
    },
    "Entranc": {
        type: ["Web", "Machine Learning", "Application", "Design"],
        thumbnail: entranc,
        shortDesc: "Hackathon winning Data sci. project",
        desc: "Carpark vacancy query and prediction system for Hong Kong. Winner of HKSTP DTT Programme hackathon. I developed this website to implement and showcase our work.",
        tags: ["HTML", "CSS", "JavaScript", "React.js",],
        onClickAction: "href",
        link: "https://boreashe.github.io/hkstpdtt/",
        palette: {
            primary: "#2C292D",
            secondary: "#68626B",
            chip: "#766E79",
            text: "#eeeeee",
            chip_text: "#C0B4C4"
        },
        leftText: "WINNER",
        exp: [
            ["Machine Learning", 14],
            ["Data Science", 7],
            ["HTML + CSS", 7],
            ["Data Visualization", 7],
            ["React.js", 7],
            ["Node.js", 2],
            ["Django", 2],
            ["Python", 14],
            ["UI/UX Design", 7],
        ],
        authors: [
            "ME", "Anson", "Ben", "Hugo"
        ],
    },
    "Managarmr": {
        type: ["Game"],
        thumbnail: managarmr,
        shortDesc: "Submission to GGJ-HK 2021",
        desc: "A simple game I and my teammates made at Global Game Jam (GGJ) Hong Kong 2021 themed \"Lost and Found\".",
        tags: ["C#", "Unity"],
        onClickAction: "dialog",
        slides: [
            {
                desc: "Made with \"Lost & Found\" theme featured on Global Game Jam 2021. I finished the map generation nad interaction logic part.",
                image: managarmr1
            },
            {
                desc: "Players are needed to gather food and find a cave for hibernation.",
                image: managarmr3
            },
            {
                desc: "Wolf mother needs to keep an eye on her stamina in order to carry all the children.",
                image: managarmr2
            }
        ],
        authors: [
            "ME",
            "Fhy",
            "1kmountains",
        ],
        exp: [
            ["Unity C#", 2],
            ["Gameplay Programming", 2],
            ["Game Mechanism Design", 1],
        ],
        link: "https://fhy.itch.io/managarmr",
        onHoverComponent: ManagarmaWidget,
        palette: {
            primary: "#6e6e66",
            secondary: "#e3d79c",
            chip: "#cbb851",
            text: "#453e19",
            chip_text: "#685d28"
        }
    },
    "Art of Life": {
        type: ["Game", "Design"],
        thumbnail: artofLife,
        shortDesc: "Causal mobile game project",
        desc: "A mobile simulation game that I am working with my teammates.",
        wip: true,
        tags: ["C#", "Unity"],
        onClickAction: "href",
        link: "https://www.instagram.com/artoflife.official/",
        palette: {
            primary: "#cee1aa",
            secondary: "#e69d3d",
            chip: "#e9dccb",
            text: "#ffffff",
            chip_text: "#807569"
        },
        authors: [
            "ME",
            "Fhy",
            "1kmountains",
        ]
    },
    "Onikiri": {
        type: ["Game"],
        thumbnail: onikiri,
        shortDesc: "Submission to Brackeys 2020.2",
        desc: "An action platformer game I and my teammates made at Brackeys Jam 2020.2 themed \"Rewind\".",
        tags: ["C#", "Unity"],
        onClickAction: "dialog",
        slides: [
            {
                desc: "Made with \"Rewind\" theme featured on Brackeys Jam 2020.2. I finished the rewind mechanism part.",
                image: onikiri1
            },
            {
                desc: "Apart from enemies, players will also face several control challenges during the level.",
                image: onikiri2
            },
            {
                desc: "Players can rewind their action as long as they are pressing on the rewind key. They can release the rewind key to resume the game.",
                image: onikiri3
            }
        ],
        authors: [
            "ME",
            "Fhy",
            "1kmountains"
        ],
        exp: [
            ["Unity C#", 4],
            ["Gameplay Programming", 4],
            ["Game Mechanism Design", 1],
        ],
        link: "https://fhy.itch.io/onikiri",
        onHoverComponent: OnikiriWidget,
        palette: {
            primary: "#e7e5d9",
            secondary: "#333D47",
            chip: "#e7e5d9",
            text: "#43C9D0",
            chip_text: "#222222"
        }
    },
    "Portfolio Site": {
        type: ["Web", "Design"],
        thumbnail: portfolioSite,
        shortDesc: "\"Sapientia et prudentia\"",
        desc: "This site! Planning to add more contents to it when I have more stuffs to show.🧙",
        tags: ["HTML", "CSS", "JavaScript", "React.js",],
        palette: {
            primary: "#0f1f33",
            secondary: "#5c4a2d",
            chip: "#706862",
            text: "#f2f2f2",
            chip_text: "#f2f2f2"
        },
        exp: [
            ["HTML + CSS", 30],
            ["React.js", 14],
            ["Node.js", 7],
            ["UI/UX Design", 30]
        ],
        authors: [
            "ME"
        ],
    },
    "Repair-Grandson": {
        type: ["Game", "Design"],
        thumbnail: repairGrandson,
        shortDesc: "Submission of GGJ-HK 2020",
        desc: "A simple game I and my teammates made at Global Game Jam (GGJ) Hong Kong 2020 themed \"Repair\".",
        tags: ["C#", "Unity"],
        onClickAction: "dialog",
        slides: [
            {
                desc: "Made with \"Repair\" theme featured on Global Game Jam 2020. I finished the game flow and interaction logic part.",
                image: repairGrandson1
            },
            {
                desc: "Players are needed to gather materials in the level to finish their objectives in the game.",
                image: repairGrandson3
            },
            {
                desc: "This game is a story-driven game and it contains an alternative ending.",
                image: repairGrandson2
            }
        ],
        exp: [
            ["Unity C#", 2],
            ["Game Mechanism Design", 2],
            ["Gameplay Programming", 2],
            ["UI/UX Design", 1]
        ],
        authors: [
            "ME",
            "Fhy",
            "1kmountains",
            "Ning"
        ],
        link: "https://fhy.itch.io/repair-grandson",
        onHoverComponent: RepairGrandsonWidget,
        palette: {
            primary: "#529095",
            secondary: "#c2c999",
            chip: "#3dc4aa",
            text: "#4e641f",
            chip_text: "#ffffff"
        }
    },
    "Hanabi": {
        type: ["Game", "Web", "Application", "Design"],
        thumbnail: hanabi,
        shortDesc: "Digital version of a famous boardgame",
        desc: "A web-based digital demo version of well-known cooperation multiplayer boardgame Hanabi (花火).",
        tags: ["Node.js", "Express.js", "Phaser 3", "Socket.io"],
        onClickAction: "dialog",
        slides: [
            {
                desc: "A Node.js lobby server and a webpage frontend is used to let players to join rooms.",
                image: hanabi1
            },
            {
                desc: "Players need to play firework cards sequentially to process the game.",
                image: hanabi2
            },
            {
                desc: "Players can give hints to other players in order to let them know what cards are in their hand.",
                image: hanabi3
            },
            {
                desc: "The detail rules of this game can be found at https://www.ultraboardgames.com/hanabi/game-rules.php.",
                image: hanabi4
            }
        ],
        authors: [
            "ME"
        ],
        exp: [
            ["Gameplay Programming", 14],
            ["HTML + CSS", 7],
            ["Node.js", 7],
            ["Phaser", 7],
            ["Express.js", 2],
            ["Socket Networking", 14],
            ["UI/UX Design", 7],
        ],
        link: "http://hanabi-game.herokuapp.com/",
        palette: {
            primary: "#1b1b1b",
            secondary: "#ffd866",
            chip: "#1b1b1b",
            text: "#1b1b1b",
            chip_text: "#ffd866"
        }
    },
    "Valhalla": {
        type: ["Game", "Design", "Application"],
        thumbnail: valhalla,
        shortDesc: "Undergrad Final Year Project",
        desc: "My solo final year project. A multiplayer 1v1 competitive turn-based card game with in-match drafting and deck building elements.",
        tags: ["C#", "Unity", "Node.js", "MySQL"],
        onClickAction: "dialog",
        slides: [
            {
                desc: "A Node.js matchmaking server is used to match players with similar rankings.",
                image: valhalla1
            },
            {
                desc: "The purpose of the game is to destroy the enemy's castle. Players have to place cards on the map to play it.",
                image: valhalla2
            },
            {
                desc: "Players need to draft three factions in the match at first and they have a equal start.",
                image: valhalla3
            },
            {
                desc: "Players can enhance their decks through the technology tree.",
                image: valhalla4
            },
            {
                desc: "Players can view the card properties interface through the hovering the card.",
                image: valhalla5
            }
        ],
        exp: [
            ["Unity C#", 30],
            ["Game Mechanism Design", 30],
            ["Gameplay Programming", 30],
            ["Prototyping", 7],
            ["Socket Networking", 30],
            ["Database", 7],
            ["UI/UX Design", 14]
        ],
        authors: [
            "ME"
        ],
        palette: {
            primary: "#4b777d",
            secondary: "#4b777d",
            chip: "#629ca4",
            text: "#eeeeee",
            chip_text: "#e9e9e9"
        }
    },
}